import { useUserId } from '~hooks/useUserId';
import { useGetGenerationImagesQuotaQuery } from '~services/api/generation/endpoints';

const initialQuota = {
	quotas: {
		free: 0,
		demo: 0,
		monthly: 0,
	},
	pricePerGeneration: 0,
	premiumMonthlyGenerations: 0,
	freeGenerations: 0,
};

export const useGetGenerationImagesQuota = () => {
	const userId = useUserId();
	const result = useGetGenerationImagesQuotaQuery(
		{ userId },
		{
			skip: !userId,
			refetchOnMountOrArgChange: true,
		}
	);

	return {
		...result,
		data: result.data || initialQuota,
	};
};
